import Box from '@mui/material/Box';

function SidebarContainer(props) {
  return <Box {...props} sx={StyleSheet.root} />;
}

SidebarContainer.displayName = 'SidebarContainer';

const StyleSheet = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
};

export default SidebarContainer;
